import { useState, useEffect } from "react";
import logo from "../images/logo.png";
import hoverLogo from "../images/logo_hover.png";
import { Link } from "react-router-dom";
import Burger from "./Burger";
import { FaInstagram } from 'react-icons/fa';
import { Moon, Sun } from "lucide-react";

const navItems = [
  { name: "Happy Hours", path: "/happyhours" },
  { name: "Featured", path: "/featured" },
  { name: "Map", path: "/map" },
  // { name: "Events", path: "/events" },
  // { name: "Specials", path: "/specials" },
  { name: "Contact", path: "/contact" },
];

const Header = ({ isDarkMode, onToggleTheme }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <div
      className={`header nav:h-[15vh] h-[10vh] w-full z-50 flex items-center justify-between border-b border-gray-300 bg-white fixed transition-all duration-300 ease-in-out ${isScrolled ? "shadow-md nav:h-[9vh]" : ""}`}
    >
      <Link
        to="/"
        className="h-full w-full sm:w-1/5 nav:w-2/5 ml-4 flex items-center"
      >
        <img
          src={isHovered ? hoverLogo : logo}
          alt="Jersey Shore Happy Hours"
          className="h-[85%] object-contain transition-transform duration-300 ease-in-out cursor-pointer"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      </Link>
      <div className="burger nav:hidden flex justify-end">
        <Burger isDarkMode={isDarkMode} onToggleTheme={onToggleTheme} />
      </div>
      <div className="menu-bar hidden nav:flex nav:justify-between items-center font-black text-blue uppercase mx-4">
        <div className="flex">
          <button
            type="button"
            onClick={onToggleTheme}
            aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
            title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
            className="flex items-center justify-center h-10 w-10 rounded-full text-blue hover:bg-gray-100 transition-colors"
          >
            {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
          </button>
        </div>
        {navItems.map((item) => (
          <div
            key={item.name}
            className="text-lg [@media(min-width:640px)_and_(max-width:675px)]:text-base ml-8" //ml-4
          >
            <Link
              to={item.path}
              className="whitespace-nowrap hover-text-light-blue transition-colors cursor-pointer"
            >
              {item.name}
            </Link>
          </div>
        ))}
        <a
          href="https://www.instagram.com/jerseyshore_happyhours"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-blue hover-text-light-blue transition ml-8" //ml-4
        >
          <FaInstagram size={28} color={"#3677cd"} />
        </a>
      </div>
    </div>
  );
};

export default Header;
